<template>
  <div class="main-container">
    <div>
      <tl-header type="h1">
        Locations
      </tl-header>
      <div class="row-container center" v-if="showIntro && (!(locationsData[le_id] && locationsData[le_id].length))">

        <div class="company-info">
          <br />
          <img class="image" src="@/assets/locations.svg" />
          <div class="fontStyle">
            <br />
            <br />
            <span>
              Location is a place where your legal entity is situated.
              You can add multiple locations for the single entity.
              The registered address for the location may or may not be the same as the head office.
            </span>
            <div class="divider"></div>
            <br />
            <br />
            <btn text="Get Started" type="secondary" @click="goToLocationsPage" />
          </div>
        </div>
      </div>
      <div v-else>
        <crud-locations />
      </div>

      <bottom-action-container class="placeAtEnd" v-if="showIntro">
        <btn-skip @navClicked="skip"></btn-skip>
      </bottom-action-container>

      <bottom-action-container class="placeAtEnd">
        <btn-skip @navClicked="navHandler"></btn-skip>
        <template slot="end">
          <btn-grp>
            <btn text="Previous" type="secondary" @click="previous" />
            <btn text="Next" type="primary" @click="next" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
import CrudLocations from "./crud_locations.vue";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "LocationsIntro",
  data() {
    return {
      showIntro: true,
      errmsg: "",
      toast: false,
    };
  },
  components: {
    CrudLocations
  },
  activated: function() {
    if (!this.locationsData[this.le_id]) {
      this.fetchLocations();
    }
  },
  computed: {
    ...mapState("onboard/locations", {
      locationsData: state => state.data
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add New";
      }
    },
    isEditMode() {
      return this.mode == "edit";
    },

    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      } else {
        return this.getleid(0);
      }
    }
  },
  methods: {
    ...mapActions({
      fetch: "onboard/locations/fetchAll",
      act_changeEditMode: "onboard/locations/changeEditMode"
    }),

    /** To navigate to Locations list screen if No location added */
    goToIntro() {
      this.showIntro = true;
    },
    /** Navigation handler */
    navHandler(navType) {
      this.$validator.reset();
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/statutory`
      });
    },
    previous() {
      this.$router.push({
        path: `/onboarding/legal_entities/${this.$route.params.entity_index}/modifyLegalEntity`
      });
    },
    next() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/statutory`
      });
    },
    async createForm() {
      try {
        await this.act_changeEditMode({ editMode: false, record: {} });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${
            this.$route.params.step_name
          }/addLocation`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To navigate to Locations list screen if already any location added */
    goToLocationsPage() {
      this.showIntro = false;
    },
    async fetchLocations() {
      try {
        await this.fetch(this.le_id);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    skip() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/statutory`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.row-container {
  .value {
    margin-right: 0;
  }
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
}

.image {
  margin-top: 35px;
}
.closeImage {
  float: right;
  cursor: pointer;
  margin: -10px;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}
.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;
}

.placeAtEnd {
  margin-top: 200px;
}

// .export-button {
// width: 70px;
// height: 25px;
// border-radius: 4px;
// font-family: Montserrat;
// font-size: 12px;
// text-align: center;
// border: 1px solid #5d409f;
// color: #5d409f;
// }
</style>
